import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  // this is the old controller that controlled the uploads drawer
}
